function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M1.54 3.02H12c.16 0 .3.07.4.2l3 3.91c.43.54.42 1.3 0 1.84l-3 3.85a.5.5 0 01-.4.19H1.54a.5.5 0 01-.5-.5V3.52c0-.28.23-.5.5-.5zm13.08 4.72l-2.87-3.72h-9.7V12h9.7l2.86-3.66a.5.5 0 00.06-.53l-.05-.08zM8.15 6.15a.5.5 0 01.78.63l-.06.07-2.44 2.54a.5.5 0 01-.64.07l-.07-.06-1.57-1.57a.5.5 0 01.63-.77l.07.06 1.21 1.21 2.1-2.18zM12 9a1 1 0 100-2 1 1 0 000 2z"
})));